/**
 * Field keys for the template editor's claimable fields (CONTEXT.md:
 * Claimable field). Opaque strings to the presence layer; only these
 * constructors should mint them.
 */

export const TITLE_FIELD_KEY = 'title';
export const DESCRIPTION_FIELD_KEY = 'description';

export function itemLabelKey(itemId: string): string {
  return `item:${itemId}:label`;
}

export function itemNotesKey(itemId: string): string {
  return `item:${itemId}:notes`;
}
